import { useEffect, useState } from "react";
import { Package, Truck, Store, ChevronRight, Search } from "lucide-react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

const eur = (n) => `${(n || 0).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
const STATUS_COLOR = {
  "Payée": "bg-green-100 text-green-700", "En préparation": "bg-blue-100 text-blue-700",
  "Expédiée": "bg-indigo-100 text-indigo-700", "Livrée": "bg-emerald-100 text-emerald-700",
  "Retirée": "bg-emerald-100 text-emerald-700", "Annulée": "bg-red-100 text-red-700",
  "À facturer": "bg-amber-100 text-amber-700",
};

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [q, setQ] = useState("");
  const [filter, setFilter] = useState("all");

  useEffect(() => { api.get("/orders").then((r) => setOrders(r.data)); }, []);

  const revenue = orders.filter((o) => ["paid", "terms"].includes(o.payment_status) && o.status !== "Annulée").reduce((s, o) => s + (o.total || 0), 0);
  const paidCount = orders.filter((o) => o.payment_status === "paid").length;
  const termsCount = orders.filter((o) => o.payment_status === "terms").length;

  const filtered = orders.filter((o) => {
    if (filter === "cb" && o.payment_status !== "paid") return false;
    if (filter === "terms" && o.payment_status !== "terms") return false;
    if (filter === "pending" && !["pending", null, undefined].includes(o.payment_status)) return false;
    if (q) {
      const s = q.toLowerCase();
      return (o.customer?.name || "").toLowerCase().includes(s) || (o.customer?.email || "").toLowerCase().includes(s) || (o.order_id || "").toLowerCase().includes(s);
    }
    return true;
  });

  return (
    <div>
      <h1 className="font-display text-4xl text-forest mb-1">Commandes</h1>
      <p className="text-stone mb-6">{paidCount} payée(s) CB · {termsCount} à facturer (30j) · <span className="font-semibold text-forest">{eur(revenue)}</span> de CA</p>

      <div className="flex flex-wrap items-center gap-3 mb-4">
        <div className="relative flex-1 min-w-[200px]">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-stone" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher (nom, email, n°)" data-testid="order-search" className="w-full rounded-lg border border-border pl-9 pr-3 py-2 text-sm" />
        </div>
        <div className="inline-flex rounded-full bg-white border border-border p-1" data-testid="order-filter">
          {[["all", "Toutes"], ["cb", "CB"], ["terms", "30j"], ["pending", "En attente"]].map(([v, l]) => (
            <button key={v} onClick={() => setFilter(v)} className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${filter === v ? "bg-brand text-white" : "text-stone hover:text-forest"}`}>{l}</button>
          ))}
        </div>
      </div>

      <div className="rounded-xl bg-white border border-border overflow-hidden">
        {filtered.length === 0 ? <p className="text-stone text-sm p-10 text-center">Aucune commande.</p> : (
          <div className="divide-y divide-border">
            {filtered.map((o) => (
              <Link key={o.id} to={`/admin/commandes/${o.order_id}`} data-testid={`order-${o.order_id}`}
                className="flex items-center gap-4 px-5 py-4 hover:bg-[#F7F7F8] transition-colors">
                <div className="h-10 w-10 rounded-full bg-brand/10 flex items-center justify-center shrink-0"><Package size={18} className="text-brand" /></div>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-forest truncate">#{String(o.order_id).slice(0, 8).toUpperCase()} · {o.customer?.name || "Client"}</p>
                  <p className="text-xs text-stone flex items-center gap-1.5">
                    {new Date(o.created_at).toLocaleDateString("fr-FR")} · {o.items?.length} article(s)
                    {o.delivery?.mode === "delivery" ? <Truck size={12} /> : <Store size={12} />}
                  </p>
                </div>
                <span className="font-semibold text-forest shrink-0 hidden sm:inline">{eur(o.total)}</span>
                <span className={`text-[10px] px-2 py-1 rounded-full font-medium shrink-0 ${STATUS_COLOR[o.status] || "bg-stone/15 text-stone"}`}>{o.status}</span>
                <ChevronRight size={16} className="text-stone shrink-0" />
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
